<template>
    <div>
        <div class="row mt-5">
            <div class="col-md-12">
                <label for="">{{ __('store.name') }}</label>
                <h2>{{ store.name ?? '-' }}</h2>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-4">
                <label for="">{{ __('store.street1') }}</label>
                <h5>{{ store.address.street1 ?? '-' }}</h5>
            </div>
            <div class="col-md-4">
                <label for="">{{ __('general.postcode') }}</label>
                <h5>{{ store.address.postcode ?? '-' }}</h5>
            </div>
            <div class="col-md-4">
                <label for="">{{ __('store.city') }}</label>
                <h5>{{ store.address.city ?? '-' }}</h5>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-4">
                <label for="">{{ __('general.country') }}</label>
                <h5 class="text-uppercase">{{ store.address.country ?? '-' }}</h5>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-4">
                <label for="">{{ __('general.phone') }}</label>
                <a v-if="store" target="_new" :href="`tel:${store.phone}`"><h5>{{ store.phone ?? '-' }}</h5></a>
                <h5 v-else>-</h5>
            </div>
            <div class="col-md-4">
                <label for="">{{ __('store.website') }}</label>
                <a v-if="store" target="_new" :href="store.website"><h5>{{ store.website ?? '-' }}</h5></a>
                <h5 v-else>-</h5>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12">
                <label for="">{{ __('store.description') }}</label>
                <div class="card">
                    <div class="card-body">
                        {{ store.description ?? '' }}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <label for="">{{ __('user-request.created_at') }}</label>
                <h5>{{ $localDate(userRequest.created_at, __('date.datetime')) }}</h5>
            </div>
            <div class="col-md-4" v-if="userRequest.created_at !== userRequest.updated_at">
                <label for="">{{ __('user-request.updated_at') }}</label>
                <h5>{{ $localDate(userRequest.updated_at, __('date.datetime')) }}</h5>
            </div>
            <div class="col-md-4">
                <label for="">{{ __('user-request.created_by') }}</label>
                <h5>{{ userRequest.user.display_name }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import UserRequestLayout from '@layouts/UserRequestLayout.vue'

export default {
    layout: UserRequestLayout,

    props: {
        userRequest: Object,
        store: Object
    },
}
</script>
